import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useConfrimCookie from "shared/model/useConfrimCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostManager = (idRef, pwRef, nameRef, franchiseData, roleType) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, , deleteConfirmCookie] = useConfrimCookie()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("POST", "/admin/auth/manager/signup", {
            "id": idRef?.current?.value,
            "password": pwRef?.current?.value,
            "name": nameRef?.current?.value,
            "franchise_idx": franchiseData?.franchise_idx,
            "role_type": roleType
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setAlert("회원가입이 완료되었습니다.")
                deleteConfirmCookie()
                navigate("/")
                break
            case 400:
                if (fetchResult?.data?.error_code === "id") setAlert("아이디를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "password") setAlert("비밀번호를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "name") setAlert("이름을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "franchise_idx") setAlert("프렌차이즈 idx를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "role_type") setAlert("권한 종류를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("프렌차이즈 정보가 존재하지 않습니다.")
                break
            case 409:
                if (fetchResult?.data?.error_code === "id") setAlert("이미 존재하는 아이디 입니다.")
                else if (fetchResult?.data?.error_code === "contact") setAlert("이미 존재하는 연락처 입니다.")
                break
        }
    }, [fetchResult])


    return [clickEvent]
}

export default usePostManager